/**
 * Diagnostic logging for auth cold-start and session flow.
 * Filter Xcode console by "[auth]" to see the full sequence.
 * Set window.__AUTH_DIAG = false to disable.
 */
const enabled = () => typeof window === 'undefined' || window.__AUTH_DIAG !== false;

export function authLog(tag, message, data = null) {
  if (!enabled()) return;
  const payload = data != null ? ` ${JSON.stringify(data)}` : '';
  console.log(`[auth] ${tag} ${message}${payload}`);
}

export function authWarn(tag, message, data = null) {
  if (!enabled()) return;
  const payload = data != null ? ` ${JSON.stringify(data)}` : '';
  console.warn(`[auth] ${tag} ${message}${payload}`);
}
